export const sanitizeAssetAllocations = (assetAllocationDataset) => {
  const requiredAssetAllocationKeys = [
    'domestic_equity',
    'domestic_property',
    'domestic_bonds',
    'domestic_cash',
    'offshore_equity',
    'offshore_property',
    'offshore_bonds',
    'offshore_cash'
  ]
  if (requiredAssetAllocationKeys.every(key => key in assetAllocationDataset)) {
    return assetAllocationDataset
  } else {
    return emptyStateAssetAllocations
  }
}

const emptyStateAssetAllocations = {
  'domestic_equity': 0,
  'domestic_property': 0,
  'domestic_bonds': 0,
  'domestic_cash': 0,
  'offshore_equity': 0,
  'offshore_property': 0,
  'offshore_bonds': 0,
  'offshore_cash': 0
}
